import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavController, MenuController } from '@ionic/angular';
import { Utils } from '../../service/utils';
import { CompleteRegistrationProvider } from './completeRegistration.service';

@Component({
  selector: 'page-complete-registration',
  templateUrl: 'completeRegistration.html',
  providers: [CompleteRegistrationProvider],
  styleUrls: ['completeRegistration.scss']
})
export class CompleteRegistrationPage {
  token: string;
  isApp: boolean;
  isSubmitted: boolean;
  isLoading: boolean;
  constructor(
    public navCtrl: NavController,
    public actRoute: ActivatedRoute,
    public menu: MenuController,
    public utils: Utils,
    public CompleteRegistration: CompleteRegistrationProvider,
    public dialog: MatDialog
  ) {
    this.isLoading = true;

    this.CompleteRegistration.completeRegistration(this.actRoute.snapshot.params['token']).subscribe(
      response => {
        this.navCtrl.navigateForward('/login');
      },
      error => {
        this.navCtrl.navigateForward('/login');
      }
    );
  }

  ngOnInit = () => {
    console.log('ionViewDidLoad ShowPage');
  };
}
